import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { getPlanDetails } from '../api/auth/planService';
// import { PreLoginUUID,PostLoginUUID,getToken,saveToken } from '../utils/auth';

function Clinicsolution() {
    const [planType, setPlanType] = useState([]);

    useEffect(() => {

        const fetchPlanDetails = async () => {
            try {
                const data = await getPlanDetails();
                setPlanType(data);
            } catch (error) {
                console.error("Error fetching Plan Details:", error.message);
            }
        };
        fetchPlanDetails();

    }, []); // ✅ add empty dependency array

    const navigate = useNavigate();


    const handleBookNow = (plan) => {
        navigate('/Booknow', { state: { plan } });
    };

    const iconMap = {
        "OPD Management Solution for Clinic / Hospital": "icofont-hospital",
        "Pathology Management Solution": "icofont-laboratory",
        "Pharmacy Billing Solution": "icofont-pills",
    };

    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Hospital / Clinic solution</h2>
                                <ul className="bread-list">
                                    <li><NavLink to='/'>Pricing</NavLink></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Hospital / Clinic solution</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="pricing-table section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2>We Provide You The Best Solution In Reasonable Price</h2>
                                <img src="img/section-img.png" alt="section" />
                                <p>We provide the best solutions at affordable and reasonable prices.</p>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        {planType.map((item, index) => (
                            <div key={index} className="col-lg-4 col-md-12 col-12">
                                <div className="single-table">
                                    <div className="table-head">
                                        <div className="icon">
                                            <i className={`icofont ${iconMap[item.plantype] || "icofont-stethoscope"}`}></i>
                                        </div>
                                        <h4 className="title">{item.plantype}</h4>
                                        <div className="price">

                                            <p className="amount">₹{item.price}
                                                {/* <span>/ GST 18%</span> */}
                                            </p>
                                        </div>
                                    </div>

                                    <ul className="table-list list-unstyled">
                                        {item.feature &&
                                            item.feature.split(",").map((f, i) => (
                                                <li key={i} className="mb-2">
                                                    <i className="fa fa-check"></i>
                                                    {f.trim()}
                                                </li>
                                            ))}
                                        <hr style={{ border: '1px solid #1279d9ff', margin: '10px 0' }}></hr>
                                        {/* Details as last line */}
                                        <li className="mt-2">
                                            {/* <i className="fa fa-check"></i> */}
                                            {item.details}
                                        </li>
                                    </ul>



                                    <div className="table-bottom">
                                        <button className="btn" onClick={() => handleBookNow(item)}>Book Now</button>


                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default Clinicsolution;
